var _rect, _rect2, _path, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 18",
    width: 20,
    height: 18,
    fill: "white",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Phone with chat bubble icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 2,
    width: 6,
    height: 14,
    rx: 1.2,
    stroke: "white",
    fill: "none",
    strokeWidth: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 3,
    width: 3,
    height: 0.6,
    rx: 0.3,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 6.5a1 1 0 0 0-1-1H9.5a1 1 0 0 0-1 1v2h-1l1.5 1.5V12a1 1 0 0 0 1 1H16a1 1 0 0 0 1-1V6.5z",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10.2,
    y: 7,
    width: 5,
    height: 0.8,
    rx: 0.4,
    fill: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 10.2,
    y: 8.5,
    width: 4.2,
    height: 0.8,
    rx: 0.4,
    fill: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 10.2,
    y: 10,
    width: 3.4,
    height: 0.8,
    rx: 0.4,
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneChatIcon);
export default __webpack_public_path__ + "static/media/phone-chat-icon.2dcf4c5f1cd411370ea5257b9bba6285.svg";
export { ForwardRef as ReactComponent };